import { SearchStatus } from "@pages/[lang]/search"
import React, { FC, Dispatch } from "react"
import { FeaturedProducts } from "../featured-products"
import { ProductGroupFilters } from "../filters/product-group-filters"
import { SizeStyleFilters } from "../filters/SizeStyleFilters"
import { NoResults } from "../no-results"
import { ResultsGrid } from "../product-grid"
import { ShowMore } from "../ShowMore"
import { Result } from "../types"
import { SearchResponse } from "@algolia/client-search"
import { FilterAction, FilterState } from "../reducer"

type ResultAreaProps = {
  hits: Result[]
  status: SearchStatus
  basicSearchResponse: SearchResponse | null
  subsequentResponse: SearchResponse | null
  state: FilterState
  dispatch: Dispatch<FilterAction>
  popularProducts: string[]
  value: string
}

export const ResultArea: FC<ResultAreaProps> = ({
  status,
  hits,
  basicSearchResponse,
  subsequentResponse,
  state,
  popularProducts,
  dispatch,
  value,
}) => {
  let render = null
  if (status === "loading") {
    render = null
  }
  if (hits.length === 0 && status !== "loading") {
    if (state.query.length > 0) {
      render = <NoResults query={state.query} />
    }
    if (value.length === 0 && state.query.length === 0) {
      render = <FeaturedProducts popularProducts={popularProducts} />
    }
  }
  if (hits.length > 0) {
    render = (
      <div>
        {basicSearchResponse && (
          <ProductGroupFilters
            dispatch={dispatch}
            nbHits={basicSearchResponse?.nbHits || 0}
            activeGroup={state.productGroup}
            facets={basicSearchResponse.facets.product_group}
          />
        )}

        {state.productGroup && subsequentResponse && (
          <SizeStyleFilters
            availableSizes={subsequentResponse?.facets?.size}
            availableStyles={subsequentResponse?.facets?.style}
            dispatch={dispatch}
            activeSize={state.size}
            activeStyle={state.style}
          />
        )}
        {basicSearchResponse && (
          <>
            <ResultsGrid items={hits} />
            <ShowMore
              totalHits={
                subsequentResponse?.nbHits || basicSearchResponse?.nbHits
              }
              hitsLength={hits.length}
              dispatch={dispatch}
            />
          </>
        )}
      </div>
    )
  }
  return render
}
